import { AbstractControl } from '@angular/forms';

export function WorksiteMax(maxLength: number) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const numberOfProjektparter = parsedValue.length;

      if (numberOfProjektparter > maxLength) {
        return { WorksiteMax: true };
      }
    }
  };
}
